/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = 767;
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

let clippyMovin;
window.playClippyAnim = (handle) => {
   if ( clippyJSON.actions.hasOwnProperty(handle) ) {
     let times = clippyJSON.actions[handle];
     clippyMovin.playSegments([times.start, times.end], false);
   }
 };

 const clippyRegion = $('.clippy-messages').get(0);

 window.clippySay = (message) => {
   const hasParagraphs = $(clippyRegion).find('p').length;
   const origParagraphs = $(clippyRegion).find('p');
   const paragraph = document.createElement('p');
   paragraph.innerHTML = message;

   const dismiss = document.createElement('button');
   dismiss.innerHTML = '<span class="screen-reader-text">Dismiss message</span>';
   dismiss.setAttribute('type', 'button');
   paragraph.appendChild(dismiss);

   clippyRegion.appendChild(paragraph);
   const height = $(paragraph).innerHeight();
   $(paragraph).hide();

   $(dismiss).on('click', function(){
     let notifDismissed = false;
     const nowHeight = $(paragraph).innerHeight();
     $(clippyRegion).find('p').each(function(){
       if ( this == paragraph ) {
         notifDismissed = true;
         $(this).fadeOut(500, () => {
           $(paragraph).remove();
           $(clippyRegion).find('p').each(function(index){
             if ( index == $(clippyRegion).find('p').length - 1 ) {
               $(this).removeClass('not-bottom');
             } else {
               $(this).addClass('not-bottom');
             }
           });
         });
       }

       if ( !notifDismissed ) {
         const thisRef = this;
         setTimeout(function(){
           gsap.to(thisRef, {
             y: '+=' + (nowHeight + 24)
           });
         }, 500);

       }
     });
   });

   if ( hasParagraphs ) {
     $(origParagraphs).addClass('not-bottom');
     gsap.to(origParagraphs, {
       y: '-=' + (height + 24)
     });
   }


   setTimeout(function(){
     $(paragraph).css({
       'display': 'block'
     });
     
     gsap.set(paragraph, {
       opacity: 0,
       scale: 0.6
     });
     
     gsap.to(paragraph, {
       scale: 1,
       ease: 'elastic.out',
       duration: 0.6
     });
     
     gsap.to(paragraph, {
       opacity: 1,
       ease: 'power3.inOut',
       duration: 0.6
     });
   }, 50);
 };

/*
 * Globals
 ***************************/
  /* Window */
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    var isMobile = ( windowWidth <= mobileBreakpoint );
  /* Navigation */
    var isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';

  /* GSAP */
    gsap.registerPlugin(ScrollTrigger);
    // gsap.registerPlugin(ScrollSmoother);

  /* ScrollSmoother */
    let smooth;

const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  smooth = false;

  if ( $('#contact-friend').length ) {
    $('#contact-friend').find('svg').remove();
    $('#contact-friend').addClass('has-bodymovin');



    clippyMovin = bodymovin.loadAnimation({
      container: document.getElementById('contact-friend'),
      renderer: 'svg',
      autoplay: false,
      path: clippyJSON.url,
      initialSegment: [0,1],
      loop: false
    });
  }

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      const isSidenav = $(this).closest('.sidenav').length > 0;
      let target = isSidenav ? $( $(this).attr('href') ).offset().top - 36 : $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION AND FOOTER SCRIPTS */
  if ( $('.menu-toggle').length ) {
    $('.menu-toggle').on('click', function(){
      $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );
      if ( $('#masthead').hasClass('menu-open') ) {
        gsap.to('.main-navigation__menu', {
          opacity: 0,
          onComplete: function() {
            $('.main-navigation__menu').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
            $('#smooth-wrapper').css({
              'visibility': 'visible',
              'pointer-events': 'auto'
            });
            $('#masthead').removeClass('menu-open');
            gsap.to('#smooth-wrapper, .fixed-background-elements, .fixed-foreground-elements', {
              opacity: 1,
              duration: 0.8,
              scale: 1,
              y: 0,
              ease: 'power3.inOut',
            });
          }
        });
      } else {
        $('#masthead').addClass('menu-open');

        gsap.to('#smooth-wrapper, .fixed-background-elements, .fixed-foreground-elements', {
          opacity: 0,
          scale: 1,
          duration: 0.8,
          ease: 'power3.inOut',
          onComplete: function() {
            $('#smooth-wrapper').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });

            $('.main-navigation__menu').css({
              'visibility': 'visible',
              'pointer-events': 'auto'
            });

            gsap.to('.main-navigation__menu', {
              opacity: 1,
            });
          }
        });


      }
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.main-navigation__menu').length ) {
    document.querySelector('.main-navigation__menu').style.setProperty('--num-top-level-nav-items', Math.max($('.main-navigation__menu-upper .menu > li').length, 6) );

    $('.main-navigation__menu-upper a, .main-navigation__menu-upper button').each(function(){
      $(this).wrapInner('<span></span>');
      const initWrap = $(this).children('span');
      const hovWrap = $(initWrap).clone().addClass('clone').attr('role', 'presentation').attr('aria-hidden', 'true');
      $(this).append(hovWrap);

      const initSplitText = new SplitText(initWrap, {
        type: 'chars'
      });

      const hovSplitText = new SplitText(hovWrap, {
        type: 'chars'
      });

      const hovTimeline = gsap.timeline({
        paused: true,
        repeat: false
      });

      gsap.set(hovSplitText.chars, {
        opacity: 0
      });

      hovTimeline.to(initSplitText.chars, {
        y: '-=100%',
        opacity: 0,
        stagger: 0.05,
        duration: 0.5,
        ease: 'power3.inOut'
      });

      hovTimeline.to(hovSplitText.chars, {
        y: '-=100%',
        opacity: 1,
        stagger: 0.05,
        duration: 0.5,
        ease: 'power3.inOut'
      }, '0.2');

      $(this).on('mouseenter', function(){
        hovTimeline.play();
      }).on('focusin', function(){
        $(this).trigger('mouseenter');
      });

      $(this).on('mouseleave', function(){
        if ( $(this).attr('aria-expanded') != 'true' ) {
          hovTimeline.reverse();
        }
      }).on('blur', function(){
        $(this).trigger('mouseleave');
      });;
    });


    $('.main-navigation__menu-upper .sub-menu-toggle').each(function(){
      $(this).on('click', function(){
        const target = $('#' + $(this).attr('aria-controls'));
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
        if ( $(this).attr('aria-expanded') == 'true' ) {
          const open = () => {
            if ( isMobile ) {
              $(target).slideDown({
                start: function () {
                  $(this).css({
                    display: "grid"
                  })
                }
              });
            } else {
              target.css({
                'visibility': 'visible',
                'pointer-events': 'auto'
              });

              gsap.to(target, {
                opacity: 1,
              });
            }
          };

          if ( $('.main-navigation__menu .sub-menu-toggle.active').length ) {
            const curactive = $('.main-navigation__menu .sub-menu-toggle.active');
            curactive.attr('aria-expanded', 'false').removeClass('active').trigger('mouseleave');
            if ( isMobile ) {
              curactive.next().slideUp(500, function(){
                open();
              });
            } else {
              gsap.to(curactive.next(), {
                opacity: 0,
                onComplete: function(){
                  curactive.next().css({
                    'visible': 'hidden',
                    'pointer-events': 'none'
                  });

                  open();
                }
              });
            }

          } else {
            open();
          }

          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
          if ( isMobile ) {
            $(target).slideUp();
          } else {
            gsap.to(target, {
              opacity: 0,
              onComplete: function(){
                target.css({
                  'visibility': 'hidden',
                  'pointer-events': 'none'
                });
              }
            });
          }
        }
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.main-navigation__menu-lower__search button[type="submit"]').length ) {
    $('.main-navigation__menu-lower__search button[type="submit"]').on('click', function(e){
      if ( $('.main-navigation__menu-lower__search input[type="search"]').val() == '' ) {
        e.preventDefault();
        $('.main-navigation__menu-lower__search input[type="search"]').focus();
      }
    });
  }

  if ( $('.site-footer__newsletter .newsletter-form__inner input').length ) {
    $('.site-footer__newsletter .newsletter-form__inner input').each(function(){
      $(this).on('focus', function(){
        $(this).closest('.site-footer').addClass('hovering');
      });

      $(this).on('blur', function(){
        $(this).closest('.site-footer').removeClass('hovering');
      });
    });
  }

  if ( $('.site-footer .site-title svg').length && $('#masthead .site-title svg').length && (!('.blog-container.infinite').length) ) {
    const swapTL = gsap.timeline({
      paused: true,
      repeat: false
    });

    swapTL.to($('#masthead .site-title svg'), {
      x: '-=100%',
      duration: 1.2,
      ease: 'power3.inOut'
    });

    swapTL.from($('.site-footer .site-title svg'), {
      x: '-=100%',
      duration: 1.2,
      ease: 'power3.inOut'
    }, '-=1.2');

    const swapTrigger = ScrollTrigger.create({
      trigger: $('.site-footer .site-title'),
      start: 'top bottom',
      end: 'bottom bottom',
      onEnter: function() {
        swapTL.play(0);
      },
      onEnterBack: function() {
        swapTL.reverse(0);
      }
    })
  }

  // footer subscribe
  if ( $('.newsletter-form').length ) {
    $('.newsletter-form').each(function(){
      const $form = $(this);
      const errorMsg = $(this).find('.newsletter-form__error-message');
      const input = $(this).find('input.email');
      const buttonContainer = $(this).find('.wp-block-button');

      $form.on('submit', function(e){
        e.preventDefault();

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache       : false,
            dataType    : 'json',
            contentType: "application/json; charset=utf-8",
            error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
            success     : function(data) {
                if (data.result != "success") {
                    // Something went wrong, do something to notify the user. maybe alert(data.msg);
                    //display an error message

                    if (data.msg[0] == "0") {
                      errorMsg.html("Please enter a valid email.");
                    } else {
                      errorMsg.html(data.msg);
                    }
                    errmorMsg.fadeIn('opacity',"1");
                } else {
                  errorMsg.fadeOut();

                  input.attr('disabled', 'true');
                  input.attr('textVal', 'Thanks for signing up!');
                  input.val('Thanks for signing up!');

                  gsap.to(buttonContainer, {
                    width: 0,
                    duration: 0.6,
                    ease: 'power3.inOut'
                  });
                }
            }
        });
      });
    });

    // end newsletter form stuff
  }
  /* END NAVIGATION AND FOOTER SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  if ( $('.gradientshifter').length ) {
    $('.gradientshifter').each(function(){
      $(this).on('mouseenter', function(){
        $('.gradient-container').addClass($(this).data('shift'));
        $(this).parent().addClass('hovering');
      });

      $(this).on('mouseleave', function(){
        $('.gradient-container').removeClass($(this).data('shift'));
        $(this).parent().removeClass('hovering');
      });
    });
  }

  if ( $('.content-card__image-hover-follower').length ) {
    $('.content-card__image-hover-follower').each(function(){
      const card = $(this).closest('.content-card');
      const hover = $(this);

      const cardOffset = {
        x: $(card).offset().left,
        y: $(card).offset().top
      };

      const hoverOffset = {
        x: $(hover).offset().left,
        y: $(hover).offset().top
      };

      console.log(cardOffset, hoverOffset);

      const pos = { x: hoverOffset.x - cardOffset.x, y: hoverOffset.y - cardOffset.y };
      const mouse = { x: pos.x, y: pos.y };
      const speed = 0.2;

      const xSet = gsap.quickSetter(hover, "x", "px");
      const ySet = gsap.quickSetter(hover, "y", "px");

      $(card).on('mousemove', function(e){
        mouse.x = e.originalEvent.pageX;
        mouse.y = e.originalEvent.pageY;
      });

      xSet(pos.x);
      ySet(pos.y);

      gsap.ticker.add(() => {
        // adjust speed for higher refresh monitors
        const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

        pos.x += ((mouse.x - cardOffset.x) - pos.x) * dt;
        pos.y += ((mouse.y - cardOffset.y) - pos.y) * dt;
        xSet(pos.x);
        ySet(pos.y);
      });
    });
  }

  // galleries
  if ( $('.flip-gallery').length ) {
    $('.flip-gallery').each(function(){
      const contentSlick = $(this).find('.flip-gallery__content-slides');
      const imageSlick = $(this).find('.flip-gallery__images');
      const controlsContainer = $(this).find('.flip-gallery__controls');

      $(contentSlick).slick({
        asNavFor: imageSlick,
        appendArrows: controlsContainer,
        instructonsText: 'This carousel displays one of the other team members at CMYK and their associated picks from the website. Use the Previous and Next buttons to navigate, or use one of the thumbnails in the next carousel to select a specific team member to display here.',
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        fade: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              adaptiveHeight: true
            }
          }
        ]
      });

      $(imageSlick).slick({
        slidesToShow: 3,
        arrows: false,
        asNavFor: contentSlick,
        instructionsText: 'This carousel displays the headshots of other team members at CMYK. Selecting a thumbnail image will change the picks and information in the preceding carousel.',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

      $(contentSlick).on('afterChange', function(){
        ScrollTrigger.refresh();
      });

      $(this).find('.flip-gallery__image-trigger').on('click', function(){
        $(contentSlick).slick('slickGoTo', $(this).data('index'));
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.get-in-touch').length ) {
    const outerContact = $('.get-in-touch');
    const numSides = $('.get-in-touch__side').length;
    
    if ( numSides > 1 ) {
      $('.get-in-touch__side').each(function(){
        const side = $(this);
        const trigger = $(this).find('.get-in-touch__side-trigger');
        const target = $( '#' + $(trigger).attr('aria-controls') );
      
        $(trigger).on('mouseenter', function(){
          outerContact.addClass('hovering');
        }).on('mouseleave', function(){
          outerContact.removeClass('hovering');
        }).on('focusin', function(){
          outerContact.addClass('hovering');
        }).on('blur', function(){
          outerContact.removeClass('hovering');
        });
      
        $(trigger).on('click', function(){
          $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
          if ( $(this).attr('aria-expanded') == 'true' ) {
            const open = () => {
              $(target).css({
                'visibilty': 'visible',
                'pointer-events': 'auto'
              });
              $(outerContact).addClass('active');
              $(side).addClass('active');
              gsap.to(target, {
                opacity: 1,
                duration: 0.6,
                y: 0,
                ease: 'power3.inOut',
              });
            };
      
            if ( $('.get-in-touch__side.active').length ) {
              const activeSide = $('.get-in-touch__side.active');
              const activetrigger = $(activeSide).find('.get-in-touch__side-trigger');
              const activetarget = $(activeSide).find('#' + activetrigger.attr('aria-controls'));
      
              activeSide.removeClass('active');
              gsap.to(activetarget, {
                opacity: 0,
                ease: 'power3.inOut',
                onComplete: function(){
                  $(activetarget).css({
                    'visibilty': 'hidden',
                    'pointer-events': 'none'
                  });
                  open();
                }
              });
            } else {
              open();
            }
      
          } else {
            $(outerContact).removeClass('active');
            gsap.to(target, {
              opacity: 0,
              y: 40,
              duration: 0.6,
              ease: 'power3.inOut',
              onComplete: function(){
                $(side).removeClass('active');
                $(target).css({
                  'visibilty': 'hidden',
                  'pointer-events': 'none'
                });
              }
            });
          }
        }).on('keypress', handleKeypressADA);
      });
    } else {
      $('.get-in-touch__side').each(function(){
        const side = $(this);
        const trigger = $(this).find('.get-in-touch__side-trigger');
        const target = $( '#' + $(trigger).attr('aria-controls') );
        
        trigger.get(0).setAttribute('disabled', 'true');
        
        $(target).css({
          'visibilty': 'visible',
          'pointer-events': 'auto'
        });
        $(outerContact).addClass('active');
        $(side).addClass('active');
        gsap.set(target, {
          opacity: 1,
          y: 0
        });
      });
    }
    
  }

  if ( $('.page-content p iframe').length ) {
    $('.page-content p').each(function(){
      if ( this.textContent == '' && $(this).find('iframe').length && $(this).find('iframe').attr('src').includes('youtube') ) {
        $(this).wrap('<div class="wp-block-embed is-type-video is-provider-youtube alignwide"></div>');
        const parent = $(this).parent();
        $(this).replaceWith(function(){
            return $('<div />', {html: $(this).html()});
        });

        $(this).find('div').addClass('wp-block-embed__wrapper');
      }

    });
  }

  if ( $('.cmyk-playlist').length ) {
    $('.cmyk-playlist').each(function(){
      const playerel = $(this).find('.plyr');
      const player = new Plyr(playerel.get(0), {
        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'pip', 'settings', 'airplay', 'fullscreen'],
        ratio: '16:9'
      });
      const aux = $(this).find('cmyk-playlist__aux');
      const scrollList = $(this).find('.cmyk-playlist__nav-list-container');
      const items = $(this).find('.cmyk-playlist__nav-list-item');

      const playlistTitle = $(this).find('.cmyk-playlist__player-info-title');
      const playlistTag = $(this).find('.cmyk-playlist__player-info-tag');
      const playlistDescription = $(this).find('.cmyk-playlist__player-info-description');

      const sourceUpdaters = [];
      let playlistIndex = 0;

      ScrollTrigger.create({
        trigger: items.eq(0).get(0),
        scroller: scrollList.get(0),
        start: 'top top+=1',
        end: '+=10000',
        toggleClass: {
          targets: aux.get(0),
          className: 'scrolled'
        }
      });



      $(items).each(function(index){
        const thisRef = $(this);
        const trigger = $(this).find('.cmyk-playlist__video-trigger');
        const title = $(this).find('.cmyk-playlist__video-title').text();
        const thumb = $(this).find('.cmyk-playlist__video-thumb img');
        const tag = $(trigger).data('tag');
        const description = $(this).find('.cmyk-playlist__video-description').html();

        const select = () => {
          $(items).removeAttr('aria-current');
          $(thisRef).attr('aria-current', 'true');
          const sourceArgs = {
            type: 'video',
            sources: []
          };

          if ( $(trigger).data('provider') == 'file' ) {
            const srcParts = $(trigger).data('src').split('.');
            sourceArgs.sources.push({
              src: $(trigger).data('src'),
              type: 'video/' + srcParts[ srcParts.length - 1 ]
            });

            if ( thumb.length && thumb.attr('src') != '' ) {
              sourceArgs.poster = thumb.attr('src');
            }
          } else {
            sourceArgs.sources.push({
              src: $(trigger).data('src'),
              provider: $(trigger).data('provider')
            });
          }

          player.source = sourceArgs;
          player.ratio('16:9');
          player.once('ready', function(){
            player.ratio('16:9');
            player.play();
          });
          playlistTitle.text(title);
          playlistTag.text(tag);
          playlistDescription.html(description);

          playlistIndex = index;

        };

        sourceUpdaters.push(select);

        trigger.on('click', function(){
          select();
        }).on('keypress', handleKeypressADA);
      });

      player.on('ended', function(){
        playlistIndex++;
        playlistIndex = playlistIndex % items.length;

        sourceUpdaters[playlistIndex]();
      });
    });
  }

  if ( $('.wp-block-embed.is-type-video').length ) {
    $('.wp-block-embed.is-type-video').each(function(){
      if ( $(this).hasClass('is-provider-vimeo') ) {
        const player = new Plyr($(this).find('iframe').parent().get(0));
      } else if ( $(this).hasClass('is-provider-youtube') ) {
        const player = new Plyr($(this).find('iframe').parent().get(0));
      }
    });
  }

  if ( $('.projects-feed').length ) {
    const filters = $(this).find('.projects-feed__filters');
    const cards = $(this).find('.content-card');
    if ( filters.length ) {
      const filterGroups = $(filters).find('.projects-feed__filters-group');
      let activeFilters = {};

      const updateFilters = () => {
        let hasFilters = false;
        cards.hide();
        cards.addClass('filters-active');

        for ( const prop in activeFilters ) {
          hasFilters = true;
          cards.each(function(){
            let showThis = true;
            if ( this.hasAttribute('data-' + prop) ) {
              let succeedsTax = false;
              const terms = $(this).data(prop);
              for ( let i = 0; i < terms.length; i++ ) {
                if ( activeFilters[prop].includes( terms[i] ) ) {
                  succeedsTax = true;
                }
              }

              showThis = showThis && succeedsTax;
            } else {
              showThis = false;
            }

            if ( showThis ) {
              $(this).fadeIn({
                complete: function(){
                  ScrollTrigger.refresh();
                }
              });
            }
          });
        }

        if ( hasFilters === false ) {
          cards.fadeIn({
            complete: function(){
              ScrollTrigger.refresh();
            }
          });
          cards.removeClass('filters-active');
        }
      };

      $(filterGroups).each(function(){
        const toggle = $(this).find('.projects-feed__filters-group__toggle');
        const fieldset = $(this).find('.projects-feed__filters-group__inputs');
        const checkboxes = $(this).find('.projects-feed__filters-group__checkbox-item');


        fieldset.hide();

        toggle.on('click', function(){
          $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
          fieldset.slideToggle();
        }).on('keypress', handleKeypressADA);

        checkboxes.on('change', function(){
          const tax = $(this).data('taxonomy');
          const term = $(this).data('term');

          if ( activeFilters.hasOwnProperty(tax) ) {
            if ( this.checked ) {
              activeFilters[tax].push( term );
            } else {
              activeFilters[tax] = activeFilters[tax].filter(e => e !== term);
              if ( activeFilters[tax].length == 0 ) {
                delete activeFilters[tax];
              }
            }
          } else {
            if ( this.checked ) {
              activeFilters[tax] = [term];
            }
          }

          updateFilters();
        });
      });
    }

    if ( $('body').hasClass('page-template-template-gradient-no-header-php') ) {
      $('.container-block').each(function(){
        if ( $(this).next().hasClass('has-round-top') ) {
          $(this).addClass('has-round-bottom-compensation');
        }
      });
    }
  }
  /* END GUTENBERG SCRIPTS */

  /* STORE SCRIPTS */
  if ( $('body').hasClass('single-product') ) {
    if ( $('div.product').length ) {
      $('div.product').each(function(){
        const product = this;
        const summary = product.querySelector('.summary.entry-summary');
        const gallery = product.querySelector('.woocommerce-product-gallery');
        const galleryInner = gallery.querySelector('.woocommerce-product-gallery__wrapper');
        const firstImage = gallery.querySelector('.woocommerce-product-gallery__image');
        const cartform = product.querySelector('form.cart');

         ScrollTrigger.matchMedia({
          '(min-width: 768px)': function() {
            ScrollTrigger.create({
              trigger: 'div.product .summary.entry-summary',
              start: 'top top+=30',
              end: function() {
                return '+=' + ( $(gallery).height() - $(summary).height());
              },
              pin: true,
              pinSpacing: false
            });
          },
          '(max-width: 767px)': function() {
            ScrollTrigger.create({
              trigger: 'body',
              start: 'top top',
              endTrigger: cartform,
              end: 'bottom top',
              onEnter: function() {
                gsap.to('#contact-friend', {
                  x: '100%',
                });
              },
              onEnterBack: function() {
                gsap.to('#contact-friend', {
                  x: '100%',
                });
              },
              onLeave: function() {
                gsap.to('#contact-friend', {
                  x: '0%',
                });
              },
              onLeaveBack: function() {
                gsap.to('#contact-friend', {
                  x: '0%',
                });
              }
            });
          }
        })
      });
    }
  }
  /* END STORE SCRIPTS */

  if ( $('.error-404__background').length ) {
    console.log( 'found' );
    $('.error-404__background').each(function(){
      $(this).find('.ring').each(function(index){
         const spinTL = gsap.timeline({
           repeat: -1,
         });

         spinTL.to(this, {
           rotate: index % 2 === 0 ? '+360deg' : '-360deg',
           ease: 'none',
           duration: 22,
           transformOrigin: 'center center'
         });
       });
    });
  }

  /* FORM SCRIPTS */
  if ( $('.gfield_select').length ) {
    $('.gfield_select').each(function(){
      if ( $(this).find('.gf_placeholder').length ) {
        $(this).addClass('placeholder-selected');

        $(this).on('change', function(){
          if ( $(this).val() == '' ) {
            $(this).addClass('placeholder-selected');
          } else {
            $(this).removeClass('placeholder-selected');
          }
        })
      }
    });
  }
  /* END FORM SCRIPTS */

  /* CMYKTV SCRIPTS */
  if ( $('.cmyk-tv-content-container__mobile-toggle button').length ) {
    $('.cmyk-tv-content-container__mobile-toggle button').on('click', function(){
      $('body').addClass('chat-open');
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  if ( $('.live-chat__title__mobile-toggle').length ) {
    $('.live-chat__title__mobile-toggle').on('click', function(){
      $('body').removeClass('chat-open');
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  if ( $('#admin-menu-trigger').length ) {
    $('#admin-menu-trigger').on('click', function(){
      $('#admin-menu').toggleClass('active');
    });
  }

  if ( $('.accent-1, .accent-2, .accent-3, .accent-4').length ) {
    $('.accent-1, .accent-2, .accent-3, .accent-4').each(function(){
      $(this).html( '<span>' + $(this).html() + '</span>' );
    });
  }

  if ( $('.jumpnav__list-item__mobile-toggle').length ) {
    $('.jumpnav__list-item__mobile-toggle').click(function(){
      if ( window.innerWidth <= 767 ) {
        $(this).next().slideToggle();
        $(this).toggleClass('open');
      }
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  // if ( $('.cmyktv-header').length ) {
  //   ScrollTrigger.create({
  //     trigger: 'body',
  //     start: 'top top',
  //     end: 'bottom top',
  //     pin: '.cmyktv-header',
  //     pinSpacing: false
  //   })
  // }

  // if ( $('.cmyk-tv-chat-container').length ) {
  //   ScrollTrigger.matchMedia({
  //     '(min-width: 768px)': function(){
  //       ScrollTrigger.create({
  //         trigger: '.cmyktv-chat-container',
  //         start: 'top top',
  //         endTrigger: 'body',
  //         end: 'bottom top',
  //         pin: '.live-chat',
  //         pinSpacing: false
  //       });
  //     }
  //   })
  // }
  /* END CMYKTV SCRIPTS */

  scrollAnimations();
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  isMobile = ( windowWidth <= mobileBreakpoint );
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Scroll Animations
 ***************************/
function scrollAnimations(){
   // homepage spiral
   if ( $('.homepage-about').length ) {
     $('.homepage-about').each(function(){
       const header = $(this).find('.homepage-about__titletag h1');
       const splitText =  new SplitText($(this).find('.homepage-about__content > *'), {
         type: 'lines'
       });

       gsap.set([header.get(0), ...splitText.lines], {
         y: 16,
         opacity: 0
       })

       ScrollTrigger.create({
         trigger: this,
         start: 'top bottom-=64',
         end: 'bottom top',
         onEnter: function() {
           gsap.to([header.get(0), ...splitText.lines], {
             y: 0,
             opacity: 1,
             stagger: 0.16,
             overwrite: true
           });
         },
         onLeave: function() {
           gsap.set([header.get(0), ...splitText.lines], {
              y: 16,
              opacity: 0,
              overwrite: true
            });
         },
         onEnterBack: function() {
           gsap.to([header.get(0), ...splitText.lines], {
              y: 0,
              opacity: 1,
              stagger: -0.16,
              overwrite: true
            });
         },
         onLeaveBack: function() {
           gsap.set([header.get(0), ...splitText.lines], {
             y: 16,
             opacity: 0,
             overwrite: true
           });
         }
       });
     });
   }

   if ( $('.homepage-spiral').length ) {
     $('.homepage-spiral').each(function(){
       const next = $(this).next();
       const svg = $(this).find('.spiralsvg');
       const bg = $('#cmykgradient');

       $('.fixed-background-elements').append(svg);

       gsap.set(svg, {
         scale: 0
       });

       const spiralTL = gsap.timeline({
         scrollTrigger: {
           trigger: this,
           start: 'top top',
           end: 'bottom top',
           scrub: 1.2
         }
       });

       spiralTL.to(svg, {
         scale: 14,
         duration: 1
       });

       const gradientSetter = gsap.quickSetter(bg, 'attr');

       const gradientTL = gsap.timeline({
         scrollTrigger: {
           trigger: this,
           start: 'top bottom',
           end: 'bottom top',
           scrub: 1.2,
           onUpdate: self => {
            const progressAdj = self.progress * 200;
            gradientSetter({
              style: `-webkit-mask-image: radial-gradient(circle, rgba(255,255,255,1) ${progressAdj-100}%, rgba(255,255,255,0) ${progressAdj}%)`
            });
          },
          onLeaveBack: self => {
            gradientSetter({
              style: ''
            });
          }
         }
       });

       $(svg).find('.spiral').each(function(index){
         const spinTL = gsap.timeline({
           repeat: -1,
         });

         spinTL.to(this, {
           rotate: index % 2 === 0 ? '+360deg' : '-360deg',
           ease: 'none',
           duration: 8,
           transformOrigin: 'center center'
         });
       });
     });
   }

   if ( $('.blog-container').length ) {
     $('.blog-container').each(function(){
       // 3d elements

       const renders = ['front', 'back'];
       const textures = [];
       const rotationSetters = [];
       const textureSetters = [];
       const renderSetters = [];

       const wedgeGeometry = new THREE.CylinderBufferGeometry( 1, 1, 2, 32, 1, true, 0, ((2 * Math.PI) / 5) - 0.1 );


       for (let renderIndex = 0; renderIndex < renders.length; renderIndex++) {
         const scene = new THREE.Scene();
         const camera = new THREE.PerspectiveCamera( 30, 1, 2, 1000 );

         const renderer = new THREE.WebGLRenderer( {
           alpha: true,
           antialias: true
         } );
         renderer.setSize( 1024, 1024 );
         $(this).find('.blog-container__feed-inner__spinner.' + renders[renderIndex]).append( renderer.domElement );

         const light = new THREE.AmbientLight( 0x404040 ); // soft white light
         scene.add( light );

         const groupOuterTilt = new THREE.Group();
         scene.add( groupOuterTilt );
         groupOuterTilt.rotation.x = -0.5;
         groupOuterTilt.rotation.z = Math.PI / 2;
         groupOuterTilt.rotation.y = 0.2;

         const group = new THREE.Group();
         groupOuterTilt.add( group );

         let cylinderFaces = [];

         const material = new THREE.MeshBasicMaterial({
           side: renders[renderIndex] == 'front' ? THREE.FrontSide : THREE.BackSide
         });

         // materials.push(material);

         const mesh = new THREE.Mesh( wedgeGeometry, material );
         mesh.rotation.set( 0, ((Math.PI * 2) / 3) - 0.24, 0 );
         group.add( mesh );

         camera.position.z = 6;

         const renderUpdater = function() {
           renderer.render( scene, camera );
         }
         renderSetters.push(renderUpdater);



         const rotationUpdater = function(val) {
           group.rotation.y = val;
           renderUpdater();
         }

         rotationSetters.push(rotationUpdater);

         const textureUpdater = function(index) {
           if ( textures.hasOwnProperty(index) ) {
             if ( textures[index] !== false ) {
               material.opacity = 1;
               material.map = textures[index];
             } else {
                material.opacity = 0;
                material.map = false;
             }
           } else {
             material.map = false;
             material.opacity = 0;
           }

           material.needsUpdate = true;

           renderUpdater();
         }
         textureSetters.push(textureUpdater);



         renderer.render( scene, camera );
       }

       const spinners = $(this).find('.blog-container__feed-inner__spinner');
       $(spinners).each(function(){
         if ( $(this).hasClass('front') ) {
           $('.fixed-foreground-elements').append($(this));
         } else {
           $('.fixed-background-elements').append($(this));
         }
       });

       // get all textures
       const texThis = this;
       const setupBlogTextures = function() {
         $(texThis).find('.blog-card').each(function(index){
           if ( !$(this).hasClass('texture-setup') ) {
             $(this).addClass('texture-setup');
             if ( $(this).find('.blog-card__thumb') ) {
               const texture = new THREE.TextureLoader().load(
                 $(this).find('.blog-card__thumb').attr('src'),
                 (tex) => {
                   tex.wrapS = THREE.RepeatWrapping;
                   tex.wrapT = THREE.RepeatWrapping;
                   tex.flipY = false;
                   tex.repeat.set( 1, 1 );
                   tex.rotation = Math.PI / -2;

                   textures[index] = tex;
                 },
                 () => {},
                 () => {
                   textures[index] = false;
                 }
               );

             } else {
               textures[index] = false;
             }
           }
         });
       };
       
       console.log(setupBlogTextures);

       window.setupBlogTextures = setupBlogTextures;
       
       if ( ! document.querySelector("#cmykintro") ) {
         setupBlogTextures();
       }

       const thisRef = this;
       const container = $(this).find('.homepage-blogs__feed');
       const inner = $(this).find('.homepage-blogs__feed-inner');

       const showSpinners = () => {
         gsap.to(spinners, {
           opacity: 1,
           scale: 1,
           duration: 0.4
         });
       };

       const hideSpinners = () => {
         gsap.to(spinners, {
           opacity: 0,
           scale: 0.8,
           duration: 0.4
         });
       };

       ScrollTrigger.create({
         trigger: container,
         start: 'top 55%',
         end: 'bottom 45%',
         onEnter: showSpinners,
         onLeave: hideSpinners,
         onEnterBack: showSpinners,
         onLeaveBack: hideSpinners
       })

       const setupBlogRotations = () => {
         $(this).find('.blog-card').each(function(index){
           if ( !$(this).hasClass('scroll-setup') ) {
             $(this).addClass('scroll-setup');
             const cardTrigger = gsap.to(this, {
               scrollTrigger: {
                 trigger: this,
                 start: 'top center',
                 end: 'bottom center',
                 toggleClass: 'active',
                 onEnter: function() {
                   for (let i = 0; i < textureSetters.length; i++) {
                     textureSetters[i](index);
                   }
                 },
                 onEnterBack: function() {
                   for (let i = 0; i < textureSetters.length; i++) {
                     textureSetters[i](index);
                   }
                 }
               }
             });

             if ( $(this).next().length ) {
               const rotationProxy = {
                 rotation: 0
               };

               const spinTrigger = gsap.to(rotationProxy, {
                 rotation: '-=' + Math.PI * 2,
                 ease: 'power2.inOut',
                 scrollTrigger: {
                   trigger: this,
                   start: 'center center',
                   endTrigger: $(this).next(),
                   end: 'center center',
                   scrub: true,
                   onUpdate: function() {
                     for (let i = 0; i < rotationSetters.length; i++) {
                       rotationSetters[i](rotationProxy.rotation);
                     }
                   }
                 }
               });
             }
           }
         });
       };

       let proxy = { skew: 0 },
           skewSetter = gsap.quickSetter('.blog-card', "skewY", "deg"),
           // fast
       clamp = gsap.utils.clamp(-1, 1); // don't let the skew go beyond 20 degrees.

       gsap.to({}, {
         scrollTrigger: {
           trigger: 'body',
           start: 'top top',
           end: 'bottom bottom',
           scrub: true,
           onUpdate: self => {
             let skew = clamp(self.getVelocity() / 300);
             // only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
             if (Math.abs(skew) > Math.abs(proxy.skew)) {
               proxy.skew = skew;
               gsap.to(proxy, { skew: 0, duration: 1.6, ease: "power3", overwrite: true, onUpdate: () => skewSetter(proxy.skew) });
             }
           }
         },
       });

       setupBlogRotations();

       if ( $(this).hasClass('infinite') ) {
         $('.site-footer').hide();
         const feed = $(this).find('.blog-container__feed-inner');
         let currentPage = 2;
         let deleteCurrentLoad = false;

         const doLoad = () => {
           if ( ajaxIsLoading === false && isDoneLoadingThings === false ) {
             ajaxIsLoading = true;

             const data = {
               action: 'do_ajax',
               fn: 'getBlogPage',
               page: currentPage
             };

             $.ajax({
               url: ajaxurl,
               data: data,
               success: function(data){
                 currentPage++;
                 if(data !== null){
                   data = JSON.parse(data);
                   console.log(data);

                   if ( deleteCurrentLoad ) {
                     $(feed).html('');
                     $(feed).removeClass('load-change');
                     $('.site-footer').hide();
                     $('.post-feed-ghost').show();
                     deleteCurrentLoad = false;
                   }

                   if ( data.more === false ) {
                     $('.post-feed-ghost').hide();
                     $('.site-footer').show();
                     isDoneLoadingThings = true;
                   }


                   $(feed).append(data.content);
                   setupBlogTextures();
                   setupBlogRotations();
                   ScrollTrigger.refresh();

                 }
               },
               complete:function(data){
                 ajaxIsLoading = false;
               },
               error: function(errorThrown) {
                 console.log(errorThrown);
               }
             });
           }
         }; // end doLoad

         const st = ScrollTrigger.create({
           trigger: feed,
           start: 'top bottom',
           end: 'bottom bottom+=800',
           onLeave: function() {
             doLoad();
           }
         });
       }
     });
   }

   // statistics block
   if ( $('.project-statistic__list-item b').length ) {
     $('.project-statistic__list-item b').each(function(index){
       const options = {
         duration: 1.2
       };

       options['prefix'] = $(this).data('prefix');
       options['suffix'] = $(this).data('suffix');

       if ( $(this).data('decimal') ) {
         options['decimalPlaces'] = $(this).data('decimal');
       }

       const counter = new CountUp($(this).get(0), 0, options);

       const num = $(this).data('num');

       const thisRef = $(this);
       $(this).parent().addClass('activated').css({
         'transition-delay': (index  * 50) + 'ms'
       });

       const counterTrigger = gsap.from(this, {
         scrollTrigger: {
           start: 'top bottom-=120',
           end: 'bottom top',
           trigger: this,
           toggleClass: 'active',
           onEnter: function() {
             if ( !$(thisRef).hasClass('added') ) {
               $(thisRef).addClass('added');
               $(thisRef).parent().addClass('added');
               counter.update(num);
             }
           },
           onLeaveBack: function() {
             $(thisRef).removeClass('added');
             $(thisRef).parent().removeClass('added');
             counter.update(0);
           }
         }
       });
     });
   }

   if ( $('.margin-block.is-style-gradient').length ) {
     $('.margin-block.is-style-gradient').each(function(){
       ScrollTrigger.create({
         trigger: this,
         start: 'top bottom',
         end: 'bottom top',
         pin: $(this).find('.margin-block__gradient'),
         pinType: 'transform'
       });
     });
   }

   if ( $('.cmyk-playlist__ticker-row').length ) {
     $('.cmyk-playlist__ticker-row').each(function(index){
       const direction = index % 2 == 0 ? -1 : 1;
       const tickerOuter = $(this);
       const tickerText = $(this).find('.cmyk-playlist__ticker-row-strip-item');
       const strip = $(this).find('.cmyk-playlist__ticker-row-strip');

       let textWidth = tickerText.outerWidth();
       let tickerWidth = tickerOuter.outerWidth();
       for ( let i = textWidth; i < tickerWidth * 4; i += textWidth ) {
         const cssObj = {};
         if ( direction == -1 ) {
           cssObj.left = i + 'px';
         } else {
           cssObj.right = i + 'px';
         }
         tickerOuter.append(tickerText.clone().css(cssObj));
       }

       let tickerAnim = gsap.timeline({
         repeat: -1
       });

       tickerAnim.to(tickerOuter.find('.cmyk-playlist__ticker-row-strip-item'), {
         x:  (100 * direction) + '%',
         ease: 'none',
         duration: 5
       });

     });
   }

   if ( $('.services-marquee').length ) {
     $('.services-marquee').each(function(){
       const rows = $(this).find('.services-marquee__strip');
       rows.each(function(index){
         const direction = index % 2 == 0 ? -1 : 1;
        const tickerOuter = $(this);
        const tickerText = $(this).find('.services-marquee__strip-inner');
        let tickerItems = $(this).find('.services-marquee__strip-item');
        let tickerAnim = gsap.timeline();
         const setupAnim = () => {
           tickerAnim.kill();
           $(tickerOuter).find('.services-marquee__strip-item[aria-role="presentation"]').remove();
           $(tickerText).css('width', 'auto');
           tickerItems = $(tickerOuter).find('.services-marquee__strip-item');
           let totalWidth = 0;
            let tickerWidth = $(window).width();
            let itCount = 0;

            const cssReset = {};
            if ( direction == -1 ) {
               cssReset.left = totalWidth + 'px';
             } else {
               cssReset.right = totalWidth + 'px';
             }

             $(tickerItems).css(cssReset);
             let animWidth = 0;


            while ( totalWidth < tickerWidth * 4 ) {
              $(tickerItems).each(function(index){
                const cssObj = {};
                console.log(totalWidth);
                if ( direction == -1 ) {
                  cssObj.left = totalWidth + 'px';
                } else {
                  cssObj.right = totalWidth + 'px';
                }

                if ( itCount > 0 ) {
                  tickerText.append(tickerItems.eq(index).clone().css(cssObj).attr('aria-role', 'presentation'));
                } else {
                  tickerText.append(tickerItems.eq(index).clone().css(cssObj));
                }

                totalWidth += tickerItems.eq(index).outerWidth();
              });

              if ( itCount == 0 ) {
                animWidth = totalWidth;
              }

              itCount++;
            }

            $(tickerText).css('width', totalWidth + 'px');

            $(tickerItems).remove();

            $(tickerText).find('.services-marquee__strip-item').on('mouseenter', function(){
              gsap.to(this, {
                skewX: -12,
                color: 'white',
              });
            }).on('mouseleave', function(){
              gsap.to(this, {
                skewX: 0,
                color: 'black'
              });
            });

            tickerAnim = gsap.timeline({
               repeat: -1
             });

             tickerAnim.to(tickerOuter.find('.services-marquee__strip-inner'), {
               x:  (animWidth * direction) + 'px',
               ease: 'none',
               duration: isMobile ? (tickerWidth / 30) : (tickerWidth / 90)
             });
         };

         setupAnim();

         $(window).on('resize', function(){
           setupAnim();
         });
       });
     });
   }

   if ( $('.icon-olist').length ) {
     $('.icon-olist').each(function(){
       const items = $(this).find('.icon-olist-item > *');
       
       gsap.set(items, {opacity: 0, y: 24});

       ScrollTrigger.batch(items, {
         onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 3]}, overwrite: true}),
          onLeave: batch => gsap.set(batch, {opacity: 0, y: -24, overwrite: true}),
          onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
          onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 24, overwrite: true})
       });
     });
   }

   if ( $('.icon-with-text').length ) {
     $('.icon-with-text').each(function(){
       const items = $(this).children();
       
       gsap.set(items, {opacity: 0, y: 24});

       ScrollTrigger.batch(items, {
         onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 3]}, overwrite: true}),
          onLeave: batch => gsap.set(batch, {opacity: 0, y: -24, overwrite: true}),
          onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
          onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 24, overwrite: true})
       });
     });
   }

   if ( $('.alternating-gallery__item').length ) {
     $('.alternating-gallery__item').each(function(){
       const items = $(this).find('.alternating-gallery__item-image, .alternating-gallery__item-content > *');
       console.log(this, items);

       gsap.set(items, {
         opacity: 0,
         y: 24
       });

       ScrollTrigger.batch(items, {
          onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
          onLeave: batch => gsap.set(batch, {opacity: 0, y: -24, overwrite: true}),
          onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
          onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 24, overwrite: true})
       });
     });
   }

   if ( $('.sidenav').length ) {
     $('.sidenav').each(function(){
       const nav = $(this).find('.sidenav__inner');
       const mobileToggle = $(this).find('.sidenav__list-item__mobile-toggle');
       mobileToggle.on('click', function(){
         $(this).next().slideToggle();
         $(this).toggleClass('open');
       }).on('keypress', handleKeypressADA);

       ScrollTrigger.matchMedia({
         '(min-width: 951px)': () => {
           const pinTL = ScrollTrigger.create({
              trigger: this,
              start: 'top top+=156',
              endTrigger: '.page-content',
              end: 'bottom bottom',
              pin: nav,
              pinType: 'fixed',
              pinSpacing: false
            });
         }
       });

       $(nav).find('a').each(function(index){
         const target = index == 0 ? 'body' : $(this).attr('href');
         const nextTarget = $(nav).find('a').eq(index + 1).length ? $(nav).find('a').eq(index + 1).attr('href') : '.site-footer__lower';
         const activeST = ScrollTrigger.create({
           trigger: target,
           start: index == 0 ? 'top top+=1' : 'top top+=149',
           endTrigger: nextTarget,
           end: 'top top+=149',
           toggleClass: {
             targets: this,
             className: 'active'
           }
         });
       });
     });
   }
   
   if ( $('.parallax-river-item').length ) {
     $('.parallax-river-item').each(function(){
       const imgareas = $(this).find('.parallax-river-item-inner');
       const imgs = $(imgareas).find('img, video');
       const bgColor = this.style.backgroundColor;
       this.style.backgroundColor = 'transparent';
       this.querySelector('.parallax-river-item-inner').style.backgroundColor = 'transparent';
       
       $(imgareas).each(function(){
          for ( let i = 0; i < 1; i++ ) {
            const follower = document.createElement('span');
            follower.classList.add('imgfollower');
            this.prepend(follower);
            
            if ( i === 0 ) {
              follower.style.backgroundColor = bgColor;
              follower.style.mixBlendMode = 'normal';
            }
            
            gsap.set(follower, {
              clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
            });
          }
        });
        
        gsap.set(imgareas, {
           y: 56
         });
         
         gsap.set(imgs, {
            clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
          });
        
        ScrollTrigger.batch(imgareas, {
           interval: 0.05, // time window (in seconds) for batching to occur. 
           batchMax: 2,   // maximum batch size (targets). Can be function-based for dynamic values
           onEnter: batch => {
             gsap.to(batch, {
               y: 0,
               overwrite: true
             });
             batch.forEach((card, index) => gsap.to( $(card).find('img, video, .imgfollower'), {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', delay: index * 0.08, stagger: 0.08, overwrite: true}))
           },
           onLeaveBack: batch => {
             gsap.set(batch, {
               y: 56,
             })
             batch.forEach((card, index) => gsap.set( $(card).find('img, video, .imgfollower'), {clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)', overwrite: true}))
           },
           start: "top bottom",
           end: "bottom top"
         });
     });
   }
   
   if ( $('.project-feed_holder, .article-card-container').length ) {
     $('.project-feed_holder, .article-card-container').each(function(){
       const imgareas = $(this).find('.content-card__image');
       const imgs = $(this).find('.content-card__image img, .content-card__image-video');
       const cards = $(this).find('.content-card');
       const contentareas = $(this).find('.content-card__content');
       
       const colNo = 3;
       
       
       if ( !$(this).hasClass('has-team-cards') ) {
         $(imgareas).each(function(){
            for ( let i = 0; i < 4; i++ ) {
              const follower = document.createElement('span');
              follower.classList.add('imgfollower');
              this.prepend(follower);
              
              gsap.set(follower, {
                clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
              });
            }
          });
          
          gsap.set(imgareas, {
            y: 56
          });
          
          
          gsap.set(imgs, {
            clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
          });
          
          gsap.set(contentareas, {
            y: 56,
            opacity: 0
          });
          
          ScrollTrigger.batch(imgareas, {
            interval: 0.05, // time window (in seconds) for batching to occur. 
            batchMax: colNo,   // maximum batch size (targets). Can be function-based for dynamic values
            onEnter: batch => {
              gsap.to(batch, {
                y: 0,
                overwrite: true
              });
              batch.forEach((card, index) => gsap.to( $(card).find('img, .content-card__image-video, .imgfollower'), {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', delay: index * 0.08, stagger: 0.08, overwrite: true}))
            },
            onLeaveBack: batch => {
              gsap.set(batch, {
                y: 56,
              })
              batch.forEach((card, index) => gsap.set( $(card).find('img, .content-card__image-video, .imgfollower'), {clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)', overwrite: true}))
            },
            start: "top bottom",
            end: "bottom top"
          });
       }
       
       
       ScrollTrigger.batch(cards, {
         interval: 0.05, // time window (in seconds) for batching to occur. 
          batchMax: colNo,   // maximum batch size (targets). Can be function-based for dynamic values
          onEnter: batch => {
             batch.forEach((card, index) => gsap.to( $(card).find('.content-card__content'), {
               y: 0,
               opacity: 1,
               delay: index * 0.08,
               stagger: 0.08,
               overwrite: true,
               onComplete:function(){
                 //fade out each target when it completes
                 gsap.set(this.targets()[0], {
                   clearProps: 'y'
                 });
               }
             }))
           },
           onLeaveBack: batch => {
             batch.forEach((card, index) => gsap.set( $(card).find('.content-card__content'), {y: 56, opacity:0, overwrite: true}))
           },
          start: "top bottom",
          end: "bottom top"
       });
       
       
     });
   }
   
   if ( $('.homepage-partnerships').length ) {
     $('.homepage-partnerships').each(function(){
       const imgs = $(this).find('.homepage-partnerships-logo img');
       
       
       gsap.set(imgs, {
         opacity: 0,
         y: 12,
       });
       
       
       ScrollTrigger.create({
         trigger: this,
         start: 'top bottom',
         end: 'bottom top',
         onEnter: () => {
           gsap.to(imgs, {
             y: 0,
             opacity: 1,
             scale: 1,
             ease: 'power3.inOut',
             duration: 0.4,
             stagger: {
               grid: 'auto',
               each: 0.04
             }
           });
         },
         onLeaveBack: () => {
           gsap.set(imgs, {
              opacity: 0,
              y: 12,
            });
         }
       });
       
     });
   }
   
   const pageEl = $('.animate-children, .content-margins, .container-margins');
   pageEl.each(function(){
     const headings = $([...$(this).children('.wp-block-heading, .post-header__title, .page-header__title, p.has-project-introduction-font-size, .project-hero__title, .project-hero__dek'), ...$(this).find('.wp-block-pullquote p, .side-card p')]);
     const paragraphs = $([ ...$(this).children('p').not('.has-project-introduction-font-size') ]);
     
     gsap.set(paragraphs, {opacity: 0, y: 24});
     
      ScrollTrigger.batch(paragraphs, {
        onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 3]}, overwrite: true}),
         onLeave: batch => gsap.set(batch, {opacity: 0, y: -24, overwrite: true}),
         onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
         onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 24, overwrite: true})
      });
     
     headings.each(function(){
       let split = new SplitText(this, {
         type: 'lines',
         linesClass: "heading-line line++"
       });
       
       $(this).find('.heading-line').wrap('<div class="line-wrapper"></div>');
       
       gsap.set(split.lines, {
         y: 56,
         opacity: 0
       });
       
       const thisRef = this;
       
       let st = ScrollTrigger.create({
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          onEnter: function() {
            gsap.to(split.lines, {
              y: 0,
              opacity: 1,
              stagger: {
                each: 0.08
              }
            });
          },
          onLeaveBack: function() {
            gsap.set(split.lines, {
              y: 56,
              opacity: 0
            });
          }
        });
       
       $(window).on('resize', function(){
         split.revert();
         st.kill();
         split = new SplitText(thisRef, {
            type: 'lines',
            linesClass: "heading-line line++"
          });
          
          $(thisRef).find('.heading-line').wrap('<div class="line-wrapper"></div>');
          
          gsap.set(split.lines, {
            y: 56,
            opacity: 0
          });
          
          st = ScrollTrigger.create({
            trigger: thisRef,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: function() {
              gsap.to(split.lines, {
                y: 0,
                opacity: 1,
                stagger: {
                  each: 0.08
                }
              });
            },
            onLeaveBack: function() {
              gsap.set(split.lines, {
                y: 56,
                opacity: 0
              });
            }
          });
       });
     });
     
     const contentBoxes = $(this).find('.nothing');
     contentBoxes.each(function() {
       const paragraphs = $(this).find('p');
       gsap.set(paragraphs, {
         opacity: 0,
         y: 16
       });
       
       ScrollTrigger.batch(paragraphs, {
         interval: 0.1, // time window (in seconds) for batching to occur. 
         batchMax: 12,   // maximum batch size (targets). Can be function-based for dynamic values
         onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 4]}, overwrite: true}),
         // onLeave: batch => gsap.set(batch, {opacity: 0, y: -16, overwrite: true}),
         // onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
         onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 16, overwrite: true}),
         start: "top bottom",
         end: "bottom top"
       })
     });
     
   });

   // footer fixed gradient
   if ( $('.site-footer__gradient').length ) {
     $('.site-footer__gradient').each(function(){
       const footer = $(this).closest('.site-footer');
       const pinTrigger = new ScrollTrigger({
         trigger: footer,
         start: 'top bottom',
         end: 'bottom top',
         pin: this,
         pinSpacing: false,
       })
     });
   }

   if ( $('#wpb').length ) {
     ScrollTrigger.create({
      trigger: ".page-content",
      start: "top top",
      end: "bottom bottom",
      // markers: true,
      toggleClass: {targets: "#wpb", className: "active"}
    });
   }

   if ( $('.clippy-trigger').length ) {
     $('.clippy-trigger').each(function(){
       const thisRef = this;
       const enqueueActions = () => {
         if ( thisRef.hasAttribute('data-message') ) {
           clippySay( $(thisRef).data('message') );
         }

         if ( thisRef.hasAttribute('data-animation') ) {
           playClippyAnim( $(thisRef).data('animation') );
         }
       };
       ScrollTrigger.create({
         trigger: this,
         start: 'top bottom-=120',
         end: 'bottom top-=120',
         onEnter: function() {
           enqueueActions();
         },
         onEnterBack: function() {
           enqueueActions();
         },
         once: true
       });
     });
   }

 }
